import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        heroImage: {
            //ratio: 1,
            width: '100%',
            cursor: 'pointer',
            maxWidth: {base: remCalc(260), md: remCalc(386), lg: remCalc(386), xl: remCalc(570)},
        },
        heroImageGroup: {
            flexDirection: 'row',
            marginBottom: {base: 'xsmall.base', lg: 'unset'},
            width: '100%',
            height: '100%',
            maxH: {
                base: remCalc(260),
                md: remCalc(386),
                lg: remCalc(386),
                xl: remCalc(570),
            },
        },
        heroImageSkeleton: {
            marginBottom: 'xsmall.base',
        },
        thumbnailImageList: {
            scrollBehavior: 'smooth',
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: {base: 'flex-start'},
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: {base: 'row', lg: 'column'},
            width: {base: 'fit-content', lg: remCalc(84)},
            height: {base: remCalc(54), md: remCalc(74), lg: 'auto'},
            maxHeight: {base: 'unset', lg: remCalc(354)},
            overflow: {base: 'scroll'},
            gap: {base: 'small.base', md: 'small.base', lg: 'xsmall.base'},
        },
        heroLeftRightArrowsContainer: {
            height: '100%',
            alignItems: 'center',
        },
        heroLeftRightArrows: {
            alignItems: 'center',
            width: [remCalc(24), remCalc(24), remCalc(24), remCalc(40)],
            height: [remCalc(24), remCalc(24), remCalc(24), remCalc(40)],
            userSelect: 'none',
        },
        thumbnailImagesUpDownArrows: {
            display: {base: 'none', lg: 'flex'},
            width: remCalc(80),
            justifyContent: 'center',
            userSelect: 'none',
        },
        thumbnailImageSkeleton: {
            width: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
        },
        thumbnailVideoSkeleton: {
            height: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
            width: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
        },
        dividerContainer: {
            display: 'flex',
            justifyContent: {base: 'center', lg: 'flex-start'},
            width: {md: remCalc(70), lg: remCalc(80)},
            // height: {base: remCalc(70), lg: 'unset'},
            my: {base: 0, lg: remCalc(12)},
        },
        icon360: {
            display: 'flex',
            height: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
            width: {base: remCalc(50), md: remCalc(70), lg: remCalc(80)},
            color: 'background.dark',
            justifyContent: 'center',
            alignItems: 'center',
        },
        infoLabelContainer: {
            flexDir: 'row',
            gap: 'xsmall.base',
            marginBottom: {base: 'medium.base', md: 'small.base'},
            justifyContent: 'flex-start',
            marginRight: {base: 'unset', md: 'auto'},
            marginLeft: {base: 'unset', md: remCalc(151), lg: remCalc(224)},
            height: remCalc(24),
        },
        sliderContainer: {
            w: {base: '100%', lg: 'unset'},
            maxW: {base: remCalc(395), md: remCalc(500), lg: 'unset'},
            gap: ['small.base', 'small.base', 'xsmall.base', 'xsmall.base'],
            flexDirection: {base: 'row', lg: 'column'},
        },
        sliderBlurredContainer: {
            w: {base: '100%', lg: 'unset'},
            justifyContent: 'center',
        },
        inGridVideoHero: {
            width: '100%',
            height: {base: remCalc(146), md: remCalc(218), lg: remCalc(218), xl: remCalc(322)},
            maxWidth: {
                base: remCalc(260),
                md: remCalc(386),
                lg: remCalc(386),
                xl: remCalc(570),
            },
            mt: {
                base: 0,
                xl: remCalc(60),
            },
        },
        videoHero: {
            width: '100%',
            height: {base: remCalc(180), md: remCalc(378), lg: 'auto'},
            maxWidth: {
                base: remCalc(290),
                md: remCalc(580),
                lg: remCalc(768),
                xl: remCalc(1024),
            },
            mt: 0,
            margin: '0 auto',
        },
        mobileMargin: {
            margin: {
                base: `${remCalc(24)} 0 ${remCalc(24)} 0`,
                lg: 0,
            },
        },
        // dynamicImage: {ratio: 1},
    },
    variants: {
        inPage: {
            thumbnailImageList: {
                margin: {
                    base: `${remCalc(24)} 0 ${remCalc(24)} 0`,
                    lg: `0 ${remCalc(24)} 0 0`,
                },
            },
            heroImageGroup: {
                justifyContent: {base: 'space-between', lg: 'center'},
                alignItems: 'center',
                gap: {base: remCalc(17.5), md: 'unset', xl: remCalc(49)},
            },
        },
        inModal: {
            heroImage: {
                //ratio: [1, 1, 1, 807 / 768],
                width: '100%',
                cursor: 'pointer',
                maxWidth: {
                    base: remCalc(285),
                    md: remCalc(559),
                    lg: remCalc(807),
                    xl: remCalc(807),
                },
                maxHeight: {
                    base: remCalc(285),
                    md: remCalc(559),
                    lg: remCalc(768),
                    xl: remCalc(768),
                },
            },
            thumbnailImageList: {
                // marginTop: {base: `auto`, lg: 'unset'},
                overflow: 'auto',
            },
            mobileMargin: {
                margin: 0,
            },
            heroImageGroup: {
                justifyContent: {base: 'space-between', lg: 'space-between'},
                alignItems: 'center',
                gap: 'unset',
                position: 'relative',
                maxH: {
                    base: remCalc(260),
                    md: remCalc(386),
                    lg: remCalc(386),
                    xl: remCalc(386),
                },
                marginBottom: [0, 0, remCalc(93), 0],
                paddingLeft: {base: remCalc(16), lg: remCalc(150)},
                paddingRight: {base: remCalc(16), lg: remCalc(44)},
            },
            sliderContainer: {
                position: ['absolute', 'absolute', 'absolute', 'unset'],
                bottom: ['8px', '8px', '8px', 'unset'],
                left: ['50%', '50%', '50%', 'unset'],
                transform: ['translateX(-50%)', 'translateX(-50%)', 'translateX(-50%)', 'unset'],
                gap: ['small.base', 'small.base', 'xsmall.base', 'xsmall.base'],
                margin: {base: 'auto', lg: `0 0 0 0`},
                zIndex: 100,
                w: {base: '96%', lg: 'unset'},
            },
            /* dynamicImage: {
                ratio: [1, 1, 1, 807 / 768],
            }, */
        },
    },
    parts: [
        'heroImage',
        'heroImageGroup',
        'heroImageSkeleton',
        'thumbnailImageList',
        'thumbnailImagesUpDownArrows',
        'thumbnailImageSkeleton',
        'thumbnailVideoSkeleton',
        'infoLabelPrimary',
        'infoLabelTertiary',
        'dividerContainer',
        'mobileMargin',
        'icon360',
        'infoLabelContainer',
        'sliderContainer',
        'placeholderVideoHero',
        'heroLeftRightArrowsContainer',
        'heroLeftRightArrows',
        'dynamicImage',
    ],
}
